export const getStringDateWithDots = (isoDate) => {
  const parsedDate = new Date(Date.parse(isoDate));
  const year = parsedDate.getFullYear();
  const month = String(parsedDate.getMonth() + 1).padStart(2, '0');
  const day = String(parsedDate.getDate()).padStart(2, '0');
  return `${day}.${month}.${year}`;
};
